/**
 * Configuratie voor document classificatie weergave.
 * Drempelwaarden bepalen hoe classificatielabels getoond worden in de UI.
 */

/** Minimum confidence om het classificatielabel te tonen. Daaronder: "Onbekend documenttype" */
export const CLASSIFICATIE_MIN_CONFIDENCE = 0.5;

/** Confidence drempel voor "hoge zekerheid" styling (groene badge) */
export const CLASSIFICATIE_HOGE_CONFIDENCE = 0.8;

/** Label dat getoond wordt als de confidence onder de minimum drempel valt */
export const CLASSIFICATIE_ONBEKEND_LABEL = "Onbekend documenttype";

/**
 * Mapping van docintel classificatie-slug naar HDN documenttype prefixen.
 * Gebruikt voor slimme sortering in het "Koppel een bestand" overzicht.
 * De HDN codes zijn prefixen — matching gaat via `startsWith()`.
 */
export const CLASSIFICATIE_NAAR_HDN: Record<string, string[]> = {
	legitimatie: ["268 ", "267 "],
	loonstrook: ["011 "],
	werkgeversverklaring: ["009 "],
	jaaropgave: ["012 "],
	bankafschrift: ["051 "],
	koopcontract: ["001 ", "002 "],
	taxatierapport: ["003 "],
	jaarrekening: ["015 "],
	aangifte_ib: ["013 ", "014 "],
	hypotheek_info: ["035 "],
	pensioen: ["029 ", "265 "],
	bkr: ["018 "],
	eigendomsinfo: ["006 "],
	uwv: ["016 "],
	inkomensverklaring: ["049 "],
};

/**
 * Fallback: keyword matching op bestandsnaam wanneer classificatie ontbreekt.
 * Keys zijn HDN documenttype prefixen, values zijn zoekwoorden (lowercase).
 */
export const BESTANDSNAAM_KEYWORDS: Record<string, string[]> = {
	"011 ": ["loonstr", "salaris", "loon"],
	"009 ": ["werkgeversverklaring", "wgv"],
	"268 ": ["paspoort", "id-bewijs", "identiteit", "rijbewijs"],
	"267 ": ["paspoort", "id-bewijs", "identiteit", "rijbewijs"],
	"051 ": ["bankafschrift", "rekeningoverzicht", "afschrift"],
	"001 ": ["koopovereenkomst", "koopcontract"],
	"002 ": ["koopovereenkomst", "koopcontract", "aanneming"],
	"003 ": ["taxatie"],
	"015 ": ["jaarrekening", "jaarstukken"],
	"013 ": ["aangifte", "ib"],
	"014 ": ["aanslag"],
	"035 ": ["hypotheek"],
	"012 ": ["jaaropgave", "jaaroverzicht"],
	"029 ": ["pensioen"],
	"018 ": ["bkr", "krediet"],
	"006 ": ["eigendom", "kadaster"],
	"016 ": ["uwv", "uitkering"],
	"049 ": ["inkomensverklaring"],
};
